// Design tokens da pilha de avisos pendentes mostrada ao entrar no painel.
//
// Mesmo card do NotificationPermissionBanner, que já vive neste canto: branco,
// rounded-xl, borda cinza clara, shadow-lg. Sem sombra colorida, sem halo, sem
// elevação no hover — o padrão do produto resolve, e o usuário já o conhece.

const BASE =
  'w-[360px] max-w-[calc(100vw-2rem)] bg-white dark:bg-[#222529] rounded-xl'
  + ' border border-gray-100 dark:border-[#383838] shadow-lg'
  + ' animate-in fade-in slide-in-from-bottom-4 duration-500 motion-reduce:animate-none';

export const AP = {
  card: `${BASE} p-4 flex items-start gap-3`,
  iconBox:
    'w-10 h-10 rounded-xl bg-violet-50 dark:bg-violet-500/10 text-[#7C3AED] dark:text-violet-300'
    + ' flex items-center justify-center shrink-0',
  body:
    'flex-1 min-w-0 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',
  titulo: 'text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] truncate',
  mensagem: 'text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5 leading-relaxed line-clamp-2',
  tempo: 'text-[11px] text-gray-400 dark:text-[#ABABAD]/70 mt-1',
  fechar:
    'text-gray-400 hover:text-gray-600 dark:text-[#ABABAD] dark:hover:text-[#D1D2D3]'
    + ' transition-colors shrink-0 p-1 rounded-md'
    + ' focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',

  overflow: `${BASE} px-4 py-2.5 flex items-center gap-3`,
  overflowLink:
    'text-[13px] font-semibold text-[#7C3AED] dark:text-violet-300 hover:underline flex-1 text-left rounded'
    + ' focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',
  overflowDispensar:
    'text-[12px] text-gray-400 dark:text-[#ABABAD] hover:text-gray-600 dark:hover:text-[#D1D2D3]'
    + ' transition-colors shrink-0 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',
};
